<router-outlet (activate)="onActivate($event)"></router-outlet>
<beygoo-security-scripts/>
